
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HealthIssueItem } from "@clients/bff";
import PhoneIcon from '@components/icons/icon-phone.svg';

@Component({
  name: 'CarHealthIssueItems',
  components: {
    PhoneIcon
  }
})
export default class CarHealthIssueItems extends Vue {
  @Prop()
  private items: HealthIssueItem[];

  @Prop({ default: true })
  private showContactButton: boolean;
}
